const RedirectToPage = () => {
  return typeof window !== 'undefined'
    ? window.open(window.location.href, '_self')
    : '';
};

export default RedirectToPage;
